import { getOAuthClientById, type OAuthClientByIdResponse } from "../oauth";
import { queryKeys } from "../queryKeys";
import { type QueryOptions, useRequest } from "./useRequest";

export const useGetOAuthClientById = ({
  clientId = "",
  options,
}: {
  clientId?: string;
  options?: QueryOptions<OAuthClientByIdResponse>;
}) => {
  const fetchOAuthClientById = async () => {
    return await getOAuthClientById(clientId);
  };

  const { data, refetch, isFetched } = useRequest(
    queryKeys.oauth.clientById(clientId),
    fetchOAuthClientById,
    {
      gcTime: 9999999,
      staleTime: Infinity,
      ...options,
    },
  );

  return { client: data, refetch, isFetched };
};
